export const SUPPORTED_CURRENCIES = ['BRL'];

export const DEFAULT_CURRENCY = SUPPORTED_CURRENCIES[0];

// Keeps limits explicit and centralized for future tuning.
export const STAGE_LIMITS = {
  MIN: 3,
  MAX: 12,
};

export const MANAGEMENT_ROLES = [
  'administrator',
  'supervisor',
  'team_supervisor',
];
